:global(.cropper-container) {
  margin-bottom: 1rem;
}

.is-right {
  display: flex;
  justify-content: flex-end;
}

.cropper-image {
  height: 100%;
  width: 100%;
}

.cropper-wrapper {
  max-height: 400px;
  width: 80%;

  :global(.cropper-view-box) {
    border-radius: 500px;
  }
}
